'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { cn } from '../../../shared/cn';
type DropdownMenuProps = {
  anchor?: Headless.MenuItemsProps;
  className?: string;
};
export function DropdownMenu(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      anchor: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const anchor = t1 === undefined ? "bottom" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("[--anchor-gap:--spacing(2)] [--anchor-padding:--spacing(1)] data-[anchor~=end]:[--anchor-offset:6px] data-[anchor~=start]:[--anchor-offset:-6px] sm:data-[anchor~=end]:[--anchor-offset:4px] sm:data-[anchor~=start]:[--anchor-offset:-4px]", "isolate w-max rounded-xl p-1", "outline outline-transparent focus:outline-hidden", "overflow-y-auto", "bg-backgroundPrimary", "border-borderPrimary border-t", "shadow-sm", "supports-[grid-template-columns:subgrid]:grid supports-[grid-template-columns:subgrid]:grid-cols-[auto_1fr_1.5rem_0.5rem_auto]", "transition data-closed:data-leave:opacity-0 data-leave:duration-100 data-leave:ease-in", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== anchor || $[7] !== props || $[8] !== t2) {
    t3 = <Headless.MenuItems {...props} transition={true} anchor={anchor} className={t2} />;
    $[6] = anchor;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}